import React, { useState, useEffect } from "react";


const Timer = ({ targetDate }) => {

  
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        Days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        Hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        Minutes: Math.floor((difference / 1000 / 60) % 60),
        Second: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }

    timerComponents.push(
      <div key={interval} className="">
        <span className="text-black mx-1">{timeLeft[interval]}</span> <br />
        <span className="text-black mx-1">{interval}</span>
      </div>
    );
  });

  return (
    <div className="d-flex flex-wrap justify-content-center align-items-center">
      {timerComponents.length ?
        <>
          {timerComponents}<img src="https://fonts.gstatic.com/s/e/notoemoji/latest/23f0/512.gif" alt=":alarm_clock:" width="32" height="32" />
        </> : <span className="text-danger">Time's up ! </span>}
    </div>
  );
};

export default Timer;
